import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M21 8V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M21 16v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M4 12H2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M10 12H8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M16 12h-2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M22 12h-2", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "FlipVertical";
const FlipVertical = memo(themed(Icon));
export {
  FlipVertical
};
//# sourceMappingURL=flip-vertical.js.map
